/**
 * Detect direct quoted client speech in clinical narrative (PRD_NOTETAKING).
 * Flags paired quote marks only — not apostrophes in contractions (don't, can't).
 */

/** Straight/curly double quotes with ≥2 characters between. */
const DOUBLE_QUOTED_SPEECH =
  /(?:^|[\s([{])["\u201C]([^\n"\u201C\u201D]{2,})["\u201D](?=[\s.,;:!?)\]}]|$)/g;

/** Straight/curly single quotes with ≥4 characters between (quoted speech, not contractions). */
const SINGLE_QUOTED_SPEECH =
  /(?:^|[\s([{])['\u2018]([^\n'\u2018\u2019]{4,})['\u2019](?=[\s.,;:!?)\]}]|$)/g;

function truncateSnippet(text: string, max = 80): string {
  const trimmed = text.trim();
  if (trimmed.length <= max) return trimmed;
  return `${trimmed.slice(0, max - 1)}…`;
}

export function extractDirectQuoteSnippets(text: string): string[] {
  if (!text.trim()) return [];
  const snippets: string[] = [];
  for (const match of text.matchAll(DOUBLE_QUOTED_SPEECH)) {
    const snippet = match[1]?.trim();
    if (snippet) snippets.push(truncateSnippet(snippet));
  }
  for (const match of text.matchAll(SINGLE_QUOTED_SPEECH)) {
    const snippet = match[1]?.trim();
    if (snippet) snippets.push(truncateSnippet(snippet));
  }
  return [...new Set(snippets)];
}

export function detectDirectQuotesInText(text: string): boolean {
  return extractDirectQuoteSnippets(text).length > 0;
}
